(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-plp-controls"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-collection-plp-controls]');
    if (!root) return;

    var sortOpenBtn = root.querySelector('[data-collection-sort-open]');
    var sortSheet = root.querySelector('[data-collection-sort-sheet]');
    var closeTriggers = root.querySelectorAll('[data-collection-sheet-close]');
    var MOTION_MS = 500;
    var closeTimer;

    function openSheet() {
      if (!sortSheet) return;
      clearTimeout(closeTimer);
      sortSheet.hidden = false;
      sortSheet.setAttribute('aria-hidden', 'false');
      if (sortOpenBtn) sortOpenBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        sortSheet.classList.add('is-open');
      });
    }

    function closeSheet() {
      if (!sortSheet) return;
      sortSheet.classList.remove('is-open');
      sortSheet.setAttribute('aria-hidden', 'true');
      if (sortOpenBtn) sortOpenBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      closeTimer = window.setTimeout(function () {
        if (!sortSheet.classList.contains('is-open')) sortSheet.hidden = true;
      }, MOTION_MS);
    }

    if (sortOpenBtn && sortSheet) {
      sortOpenBtn.addEventListener('click', function () {
        if (sortSheet.classList.contains('is-open')) {
          closeSheet();
        } else {
          openSheet();
        }
      });
    }

    closeTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', closeSheet);
    });

    sortSheet.addEventListener('click', function (event) {
      if (event.target === sortSheet) closeSheet();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSheet();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["corporate-discount-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__corpDiscInit) return;
    window.__corpDiscInit = true;

    var STORAGE_AUTOOPEN = 'corp_disc_autoopen';

    var root = document.querySelector('[data-corp-disc-root]');
    if (!root) return;

    var AUTH_BASE = root.getAttribute('data-auth-base') || 'https://evolv-auth-backend.onrender.com';
    var fab = root.querySelector('[data-corp-disc-fab]');
    var overlay = root.querySelector('[data-corp-disc-overlay]');
    var closeBtn = root.querySelector('[data-corp-disc-close]');
    var subtitleEl = root.querySelector('[data-corp-disc-subtitle]');
    var offersEl = root.querySelector('[data-corp-disc-offers]');
    var subtitleTemplate = root.getAttribute('data-subtitle-template') || '';
    var subtitleFallback = root.getAttribute('data-subtitle-fallback') || '';
    var exploreLabel = root.getAttribute('data-explore-label') || 'Explore';
    var allProductsLabel = root.getAttribute('data-all-products-label') || 'All products';
    var eventsBound = false;

    function getCookie(name) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    }

    function updateSubtitle(company) {
      if (!subtitleEl) return;
      if (company && subtitleTemplate.indexOf('@@') !== -1) {
        subtitleEl.textContent = subtitleTemplate.replace('@@', company);
      } else {
        subtitleEl.textContent = subtitleFallback;
      }
    }

    function offerRow(name, percent, url) {
      var row = document.createElement('div');
      row.className = 'corp-disc-offer';

      var info = document.createElement('div');
      info.className = 'corp-disc-offer__info';

      var nameEl = document.createElement('span');
      nameEl.className = 'corp-disc-offer__name';
      nameEl.textContent = name;
      info.appendChild(nameEl);

      if (percent) {
        var chip = document.createElement('span');
        chip.className = 'corp-disc-offer__chip';
        chip.textContent = percent + '% OFF';
        info.appendChild(chip);
      }

      var explore = document.createElement('a');
      explore.className = 'corp-disc-offer__explore';
      explore.href = url;
      explore.textContent = exploreLabel;

      row.appendChild(info);
      row.appendChild(explore);
      return row;
    }

    function renderOffers(data) {
      var collections = (data && data.collections) || [];
      offersEl.innerHTML = '';

      if (collections.length) {
        // Company with linked collections: only those products are discounted,
        // so the listed collections are the complete offer (the backend sends
        // no basePercent in this case).
        collections.forEach(function (c) {
          if (!c || !c.handle) return;
          offersEl.appendChild(offerRow(c.name || c.handle, Number(c.percent) || 0, '/collections/' + c.handle));
        });
      } else if (data && data.basePercent) {
        // Flat-rate company: no per-collection offers, everything is discounted.
        offersEl.appendChild(offerRow(allProductsLabel, Number(data.basePercent) || 0, '/collections/all'));
      } else {
        return false; // nothing to show
      }

      updateSubtitle(data && data.companyName);
      return true;
    }

    function bindEvents() {
      if (eventsBound) return;
      eventsBound = true;

      fab.addEventListener('click', open);
      closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) close();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && overlay.classList.contains('corp-disc-overlay--open')) {
          close();
        }
      });
    }

    function open() {
      overlay.classList.add('corp-disc-overlay--open');
      fab.setAttribute('aria-expanded', 'true');
      overlay.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      overlay.classList.remove('corp-disc-overlay--open');
      fab.setAttribute('aria-expanded', 'false');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function maybeAutoOpen() {
      var flag;
      try {
        flag = localStorage.getItem(STORAGE_AUTOOPEN);
      } catch (e) {
        flag = null;
      }
      if (!flag) return;

      try {
        localStorage.removeItem(STORAGE_AUTOOPEN);
      } catch (e) {}

      // Wait a frame so the root is no longer hidden and the open transition plays.
      requestAnimationFrame(function () {
        requestAnimationFrame(open);
      });
    }

    function init() {
      var session = getCookie('corp_session');
      if (!session) return; // not logged in

      fetch(AUTH_BASE + '/offers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ sessionToken: session })
      })
        .then(function (res) { return res.json().catch(function () { return {}; }); })
        .then(function (data) {
          if (renderOffers(data)) {
            root.hidden = false;
            bindEvents();
            maybeAutoOpen();
          }
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer-motion"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.DrawerMotion) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function create(options) {
      var root = options.root;
      var panel = options.panel;
      var backdrop = options.backdrop;
      var cascadeSelector = options.cascadeSelector;
      var getFocusTarget = options.getFocusTarget;
      var getReturnFocus = options.getReturnFocus;
      var onExpandedChange = options.onExpandedChange || function () {};

      var phase = 'closed';
      var contentRevealed = false;
      var focusOnClose = false;
      var lastFocus = null;
      var contentInTimer;
      var contentOutTimer;
      var closeFallbackTimer;

      function clearTimers() {
        clearTimeout(contentInTimer);
        clearTimeout(contentOutTimer);
        clearTimeout(closeFallbackTimer);
      }

      function applyStagger() {
        if (!cascadeSelector) return;
        root.querySelectorAll(cascadeSelector).forEach(function (node, index) {
          node.style.setProperty('--drawer-item-delay', 100 + index * 30 + 'ms');
        });
      }

      function clearStagger() {
        if (!cascadeSelector) return;
        root.querySelectorAll(cascadeSelector).forEach(function (node) {
          node.style.removeProperty('--drawer-item-delay');
        });
      }

      function resetContentAnimation() {
        root.classList.remove('is-content-in', 'is-content-out');
        contentRevealed = false;
      }

      function finishClose() {
        if (phase !== 'closing') return;

        clearTimeout(closeFallbackTimer);
        phase = 'closed';
        root.hidden = true;
        root.setAttribute('aria-hidden', 'true');
        root.classList.remove('is-open', 'is-panel-in', 'is-panel-out', 'is-content-in', 'is-content-out');
        if (backdrop) backdrop.classList.remove('is-closing');
        clearStagger();
        resetContentAnimation();
        document.body.style.overflow = '';
        onExpandedChange(false);

        if (focusOnClose) {
          var returnTarget = getReturnFocus ? getReturnFocus() : lastFocus;
          if (returnTarget && returnTarget.focus) returnTarget.focus();
        }
        focusOnClose = false;
      }

      function scheduleContentIn() {
        clearTimeout(contentInTimer);
        contentInTimer = window.setTimeout(function () {
          if (phase !== 'opening' && phase !== 'open') return;
          root.classList.add('is-content-in');
          contentRevealed = true;
          if (phase === 'opening') phase = 'open';
        }, 100);
      }

      function slidePanelOpen() {
        root.classList.remove('is-panel-out', 'is-content-out');
        if (backdrop) backdrop.classList.remove('is-closing');

        requestAnimationFrame(function () {
          if (phase !== 'opening') return;
          root.classList.add('is-open', 'is-panel-in');
          if (panel) panel.offsetHeight;
          scheduleContentIn();
        });
      }

      function slidePanelClosed() {
        if (phase !== 'closing') return;

        requestAnimationFrame(function () {
          if (phase !== 'closing') return;

          var hadPanelIn = root.classList.contains('is-panel-in');
          root.classList.remove('is-content-out', 'is-panel-in', 'is-open');
          root.classList.add('is-panel-out');
          if (backdrop) backdrop.classList.add('is-closing');

          if (!hadPanelIn) {
            finishClose();
            return;
          }

          if (panel) panel.offsetHeight;

          clearTimeout(closeFallbackTimer);
          closeFallbackTimer = window.setTimeout(function () {
            if (phase === 'closing') finishClose();
          }, 450);
        });
      }

      function open() {
        if (phase === 'opening' || phase === 'open') return;

        clearTimers();
        focusOnClose = false;
        lastFocus = document.activeElement;
        root.hidden = false;
        root.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        onExpandedChange(true);
        applyStagger();

        var focusTarget = getFocusTarget ? getFocusTarget() : null;

        if (reducedMotion) {
          phase = 'open';
          root.classList.remove('is-panel-out', 'is-content-out');
          root.classList.add('is-open', 'is-panel-in', 'is-content-in');
          contentRevealed = true;
          if (focusTarget && focusTarget.focus) focusTarget.focus();
          return;
        }

        if (phase === 'closing') {
          phase = 'opening';
          resetContentAnimation();
          slidePanelOpen();
          if (focusTarget && focusTarget.focus) focusTarget.focus();
          return;
        }

        phase = 'opening';
        resetContentAnimation();
        root.classList.remove('is-panel-in', 'is-panel-out', 'is-open', 'is-content-in', 'is-content-out');
        if (panel) panel.offsetHeight;

        requestAnimationFrame(function () {
          slidePanelOpen();
          if (focusTarget && focusTarget.focus) focusTarget.focus();
        });
      }

      function close() {
        if (phase === 'closed' || phase === 'closing') return;

        clearTimers();
        phase = 'closing';
        focusOnClose = true;
        onExpandedChange(false);

        if (reducedMotion) {
          root.classList.remove('is-open', 'is-panel-in', 'is-content-in');
          finishClose();
          return;
        }

        var contentOutDelay = contentRevealed ? 160 : 0;

        root.classList.remove('is-content-in');
        root.classList.add('is-content-out');

        contentOutTimer = window.setTimeout(slidePanelClosed, contentOutDelay);
      }

      function toggle() {
        if (phase === 'opening' || phase === 'open') {
          close();
        } else {
          open();
        }
      }

      if (panel) {
        panel.addEventListener('transitionend', function (event) {
          if (event.target !== panel || event.propertyName !== 'transform') return;

          if (root.classList.contains('is-panel-in') && !root.classList.contains('is-panel-out')) {
            if (phase === 'opening') phase = 'open';
            return;
          }

          if (root.classList.contains('is-panel-out') && !root.classList.contains('is-panel-in')) {
            clearTimeout(closeFallbackTimer);
            finishClose();
          }
        });
      }

      return {
        open: open,
        close: close,
        toggle: toggle,
        getPhase: function () {
          return phase;
        },
        isVisible: function () {
          return phase !== 'closed';
        }
      };
    }

    window.DrawerMotion = {
      create: create,
      reducedMotion: reducedMotion
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["motion-ui"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__motionUiInit) return;
    window.__motionUiInit = true;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lastCartCount = null;
    var badgePopTimer;

    function easeEnter(t) {
      return cubicBezier(t, 0.32, 0.08, 0.24, 1);
    }

    function easeExit(t) {
      return cubicBezier(t, 0.4, 0, 0.6, 1);
    }

    function cubicBezier(p, x1, y1, x2, y2) {
      var cx = 3 * x1;
      var bx = 3 * (x2 - x1) - cx;
      var ax = 1 - cx - bx;
      var cy = 3 * y1;
      var by = 3 * (y2 - y1) - cy;
      var ay = 1 - cy - by;

      function sampleX(t) {
        return ((ax * t + bx) * t + cx) * t;
      }

      function sampleY(t) {
        return ((ay * t + by) * t + cy) * t;
      }

      function sampleDerivativeX(t) {
        return (3 * ax * t + 2 * bx) * t + cx;
      }

      function solveT(x) {
        var t = x;
        for (var i = 0; i < 8; i++) {
          var currentX = sampleX(t) - x;
          if (Math.abs(currentX) < 1e-5) return t;
          var d = sampleDerivativeX(t);
          if (Math.abs(d) < 1e-6) break;
          t -= currentX / d;
        }
        var lower = 0;
        var upper = 1;
        t = x;
        while (lower < upper) {
          var solvedX = sampleX(t);
          if (Math.abs(solvedX - x) < 1e-5) return t;
          if (x > solvedX) lower = t;
          else upper = t;
          t = (lower + upper) / 2;
        }
        return t;
      }

      return sampleY(solveT(p));
    }

    function isAboveFold(el) {
      var rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight * 0.85 && rect.bottom > 0;
    }

    function collectRevealItems(root) {
      var items = [];
      var seen = new Set();

      function add(node) {
        if (!node || seen.has(node)) return;
        seen.add(node);
        items.push(node);
      }

      root.querySelectorAll('[data-reveal-stagger] > *').forEach(function (child) {
        if (child.tagName === 'THEME-CAROUSEL') return;
        add(child);
      });

      if (root.matches('[data-reveal-stagger]')) {
        Array.prototype.slice.call(root.children).forEach(function (child) {
          if (child.tagName === 'THEME-CAROUSEL') return;
          add(child);
        });
      }

      root.querySelectorAll('[data-reveal-item]').forEach(add);
      root.querySelectorAll('theme-carousel .theme-carousel__slide').forEach(add);
      root.querySelectorAll('theme-carousel > *').forEach(function (child) {
        if (child.classList.contains('theme-carousel__viewport')) return;
        if (child.classList.contains('theme-carousel__arrow')) return;
        if (child.classList.contains('theme-carousel__dots')) return;
        add(child);
      });

      if (!items.length) add(root);

      items.sort(function (a, b) {
        if (a === b) return 0;
        var pos = a.compareDocumentPosition(b);
        if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
        if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
        return 0;
      });

      return items;
    }

    function revealItems(items, instant) {
      items.forEach(function (item, index) {
        item.classList.remove('motion-reveal--pending');
        if (!instant && !reducedMotion) {
          item.style.setProperty('--motion-reveal-delay', Math.min(index, 5) * 60 + 'ms');
        } else {
          item.style.removeProperty('--motion-reveal-delay');
        }
        item.classList.add('motion-reveal--visible');
        if (instant) item.classList.add('motion-reveal--instant');
      });
    }

    function markRevealPending(items) {
      items.forEach(function (item) {
        if (item.classList.contains('motion-reveal--visible')) return;
        item.classList.remove('motion-reveal--instant');
        item.classList.add('motion-reveal--pending');
      });
    }

    function scheduleRevealRoots(roots, observer) {
      roots.forEach(function (root) {
        if (root.closest('.home-hero, .site-header, .cart-drawer, [data-site-header]')) return;

        var items = collectRevealItems(root);
        if (!items.length) return;

        if (isAboveFold(root)) {
          revealItems(items, true);
          root.setAttribute('data-reveal-complete', '');
          return;
        }

        if (root.hasAttribute('data-reveal-complete')) return;
        if (root.hasAttribute('data-reveal-watching')) return;

        markRevealPending(items);
        observer.observe(root);
        root.setAttribute('data-reveal-watching', '');
      });
    }

    function initScrollReveal() {
      if (reducedMotion) {
        document.documentElement.setAttribute('data-reveal-ready', '');
        document.documentElement.setAttribute('data-reveal-reduced', '');
        return;
      }

      document.documentElement.setAttribute('data-reveal-ready', '');

      var roots = Array.prototype.slice.call(
        document.querySelectorAll('[data-reveal]:not([data-reveal-skip])')
      );

      if (!roots.length) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var root = entry.target;
            var items = collectRevealItems(root);
            revealItems(items, false);
            root.setAttribute('data-reveal-complete', '');
            root.removeAttribute('data-reveal-watching');
            observer.unobserve(root);
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -10% 0px'
        }
      );

      scheduleRevealRoots(roots, observer);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scheduleRevealRoots(roots, observer);
        });
      });

      if (typeof MutationObserver === 'undefined') return;

      var carouselObserver = new MutationObserver(function () {
        scheduleRevealRoots(roots, observer);
      });

      document.querySelectorAll('theme-carousel').forEach(function (carousel) {
        carouselObserver.observe(carousel, { childList: true, subtree: true });
      });

      var gridObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type !== 'childList') return;
          var stagger = mutation.target;
          if (!stagger.matches('[data-reveal-stagger][data-reveal-complete]')) return;

          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.parentElement !== stagger) return;
            revealItems([node], true);
          });
        });
      });

      document.querySelectorAll('[data-reveal-stagger]').forEach(function (stagger) {
        gridObserver.observe(stagger, { childList: true });
      });
    }

    function getCartTrigger() {
      return document.querySelector('[data-cart-drawer-open]');
    }

    function getHeaderCartCount() {
      var badge = document.querySelector('[data-cart-drawer-open] .site-header__cart-count');
      if (badge) return parseInt(badge.textContent, 10) || 0;
      return 0;
    }

    function popCartBadge(badge, newCount, oldCount) {
      badge.classList.remove('motion-badge--decrease', 'motion-badge--hide');
      badge.classList.remove('motion-badge--pop');
      void badge.offsetWidth;

      if (typeof oldCount === 'number' && oldCount >= 0 && oldCount !== newCount) {
        badge.textContent = String(oldCount);
      }

      var swapAt = reducedMotion ? 75 : 150;
      badgePopTimer = setTimeout(function () {
        badge.textContent = String(newCount);
      }, swapAt);

      badge.classList.add('motion-badge--pop');

      badge.addEventListener(
        'animationend',
        function () {
          badge.classList.remove('motion-badge--pop');
        },
        { once: true }
      );
    }

    function syncCartBadge(newCount, prevCount) {
      clearTimeout(badgePopTimer);

      var trigger = getCartTrigger();
      if (!trigger) return;
      if (typeof newCount !== 'number' || isNaN(newCount)) return;

      var badge = trigger.querySelector('.site-header__cart-count');

      if (newCount <= 0) {
        if (badge) {
          badge.classList.remove('motion-badge--pop', 'motion-badge--decrease');
          badge.classList.add('motion-badge--hide');
          badgePopTimer = setTimeout(function () {
            if (badge.parentNode) badge.remove();
          }, 200);
        }
        lastCartCount = 0;
        return;
      }

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'site-header__cart-count';
        trigger.appendChild(badge);
      }

      badge.classList.remove('motion-badge--hide');

      if (typeof prevCount === 'number' && newCount > prevCount) {
        popCartBadge(badge, newCount, prevCount);
      } else if (typeof prevCount === 'number' && newCount < prevCount) {
        badge.classList.remove('motion-badge--pop');
        badge.textContent = String(newCount);
        badge.classList.remove('motion-badge--decrease');
        void badge.offsetWidth;
        badge.classList.add('motion-badge--decrease');
      } else {
        badge.classList.remove('motion-badge--pop', 'motion-badge--decrease');
        badge.textContent = String(newCount);
      }

      lastCartCount = newCount;
    }

    function initCartBadgePop() {
      lastCartCount = getHeaderCartCount();

      document.addEventListener('cart:updated', function (event) {
        var newCount;
        if (event.detail && typeof event.detail.item_count === 'number') {
          newCount = event.detail.item_count;
        } else {
          var node = document.querySelector('#CartDrawerContents [data-cart-count]');
          newCount = node ? parseInt(node.getAttribute('data-cart-count'), 10) : lastCartCount;
          if (isNaN(newCount)) newCount = lastCartCount;
        }

        syncCartBadge(newCount, lastCartCount);
      });
    }

    var pressSelector =
      'button, input[type="submit"], input[type="button"], input[type="reset"], .cart-stepper__btn, .theme-carousel__arrow, .theme-carousel__dot, .pdp-form__submit, .product-card__submit, .cart-checkout__btn, .collection-plp-controls__apply, .collection-plp-controls__pill';

    function shouldApplyPress(el) {
      if (!el || el.disabled) return false;
      if (el.closest('.site-header, .site-header__drawer')) return false;
      if (el.closest('summary')) return false;
      if (el.matches('a[href]:not([role="button"])')) return false;
      if (el.matches('[data-no-motion-press]')) return false;

      if (el.matches(pressSelector)) return true;

      return false;
    }

    function clearPressState() {
      document.querySelectorAll('.motion-press--active').forEach(function (el) {
        el.classList.remove('motion-press--active');
      });
    }

    function initButtonPress() {
      document.documentElement.setAttribute('data-motion-press-ready', '');
      if (reducedMotion) {
        document.documentElement.setAttribute('data-reveal-reduced', '');
      }

      document.addEventListener(
        'pointerdown',
        function (event) {
          if (event.button !== 0) return;
          var el = event.target.closest(pressSelector);
          if (!shouldApplyPress(el)) return;
          el.classList.add('motion-press--active');
        },
        { passive: true }
      );

      document.addEventListener('pointerup', clearPressState, { passive: true });
      document.addEventListener('pointercancel', clearPressState, { passive: true });
      document.addEventListener('pointerleave', function (event) {
        if (event.target && event.target.classList && event.target.classList.contains('motion-press--active')) {
          event.target.classList.remove('motion-press--active');
        }
      }, true);

      document.querySelectorAll(pressSelector).forEach(function (el) {
        if (shouldApplyPress(el)) el.classList.add('motion-press-target');
      });

      if (typeof MutationObserver === 'undefined') return;

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (shouldApplyPress(node)) node.classList.add('motion-press-target');
            node.querySelectorAll &&
              node.querySelectorAll(pressSelector).forEach(function (el) {
                if (shouldApplyPress(el)) el.classList.add('motion-press-target');
              });
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    function animatePanelHeight(panel, from, to, duration, easeFn, onComplete) {
      var start = performance.now();
      var frameId;
      panel.style.overflow = 'hidden';
      panel.style.height = from + 'px';

      function frame(now) {
        var elapsed = now - start;
        var progress = Math.min(elapsed / duration, 1);
        panel.style.height = from + (to - from) * easeFn(progress) + 'px';
        if (progress < 1) {
          frameId = requestAnimationFrame(frame);
        } else {
          onComplete();
        }
      }

      frameId = requestAnimationFrame(frame);

      return function cancel() {
        cancelAnimationFrame(frameId);
      };
    }

    function initAccordion(details) {
      if (details.dataset.motionAccordionInit) return;
      details.dataset.motionAccordionInit = 'true';

      var summary = details.querySelector('summary');
      if (!summary) return;

      var body = summary.nextElementSibling;
      if (!body) return;

      var panel = document.createElement('div');
      panel.className = 'motion-accordion__panel';
      var inner = document.createElement('div');
      inner.className = 'motion-accordion__inner';

      details.insertBefore(panel, body);
      inner.appendChild(body);
      panel.appendChild(inner);

      var state = {
        phase: details.hasAttribute('open') ? 'open' : 'closed',
        cancelAnim: null
      };

      if (details.hasAttribute('open')) {
        details.classList.add('is-accordion-open');
        panel.style.height = 'auto';
        inner.style.opacity = '1';
      } else {
        details.removeAttribute('open');
        panel.style.height = '0px';
      }

      function measureFullHeight() {
        panel.style.height = 'auto';
        var height = panel.scrollHeight;
        panel.style.height = state.phase === 'open' ? 'auto' : '0px';
        return height;
      }

      function cancelAnimation() {
        if (state.cancelAnim) {
          state.cancelAnim();
          state.cancelAnim = null;
        }
      }

      function finishOpen() {
        panel.style.height = 'auto';
        panel.style.overflow = '';
        details.classList.remove('is-accordion-closing');
        details.classList.add('is-accordion-open');
        state.phase = 'open';
        state.cancelAnim = null;
      }

      function finishClose() {
        panel.style.height = '0px';
        panel.style.overflow = '';
        details.removeAttribute('open');
        details.classList.remove('is-accordion-open', 'is-accordion-closing');
        state.phase = 'closed';
        state.cancelAnim = null;
      }

      function openAccordion() {
        cancelAnimation();
        var from = panel.offsetHeight;
        details.setAttribute('open', '');
        details.classList.remove('is-accordion-closing');
        details.classList.add('is-accordion-open');
        var to = measureFullHeight();

        if (reducedMotion || Math.abs(to - from) < 1) {
          finishOpen();
          return;
        }

        state.phase = 'opening';
        state.cancelAnim = animatePanelHeight(panel, from, to, 400, easeEnter, function () {
          state.phase = 'open';
          finishOpen();
        });
      }

      function closeAccordion() {
        cancelAnimation();
        var from = panel.offsetHeight;
        if (from <= 0) {
          finishClose();
          return;
        }

        details.classList.add('is-accordion-closing');
        details.classList.remove('is-accordion-open');
        state.phase = 'closing';

        if (reducedMotion) {
          finishClose();
          return;
        }

        state.cancelAnim = animatePanelHeight(panel, from, 0, 320, easeExit, function () {
          state.phase = 'closed';
          finishClose();
        });
      }

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (state.phase === 'opening' || state.phase === 'open') {
          closeAccordion();
        } else {
          openAccordion();
        }
      });
    }

    function initAccordions() {
      document.querySelectorAll('[data-motion-accordion]').forEach(initAccordion);

      if (typeof MutationObserver === 'undefined') return;

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('[data-motion-accordion]')) initAccordion(node);
            node.querySelectorAll &&
              node.querySelectorAll('[data-motion-accordion]').forEach(initAccordion);
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    window.MotionUI = {
      syncCartBadge: syncCartBadge,
      initAccordions: initAccordions
    };

    function boot() {
      initScrollReveal();
      initCartBadgePop();
      initButtonPress();
      initAccordions();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('theme-carousel')) return;

    var SCROLL_DURATION = 560;
    var SETTLE_DURATION = 400;
    var DRAG_THRESHOLD = 6;
    var VELOCITY_WINDOW = 100;
    var MOMENTUM_MIN_VELOCITY = 0.08;
    var FLICK_VELOCITY = 0.45;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function parseBool(value, fallback) {
      if (value == null || value === '') return fallback;
      return value === 'true' || value === '';
    }

    function cubicBezier(p, x1, y1, x2, y2) {
      var cx = 3 * x1;
      var bx = 3 * (x2 - x1) - cx;
      var ax = 1 - cx - bx;
      var cy = 3 * y1;
      var by = 3 * (y2 - y1) - cy;
      var ay = 1 - cy - by;

      function sampleX(t) {
        return ((ax * t + bx) * t + cx) * t;
      }

      function sampleY(t) {
        return ((ay * t + by) * t + cy) * t;
      }

      function sampleDerivativeX(t) {
        return (3 * ax * t + 2 * bx) * t + cx;
      }

      function solveT(x) {
        var t = x;
        for (var i = 0; i < 8; i++) {
          var currentX = sampleX(t) - x;
          if (Math.abs(currentX) < 1e-5) return t;
          var d = sampleDerivativeX(t);
          if (Math.abs(d) < 1e-6) break;
          t -= currentX / d;
        }
        var lower = 0;
        var upper = 1;
        t = x;
        while (lower < upper) {
          var solvedX = sampleX(t);
          if (Math.abs(solvedX - x) < 1e-5) return t;
          if (x > solvedX) lower = t;
          else upper = t;
          t = (lower + upper) / 2;
        }
        return t;
      }

      return sampleY(solveT(p));
    }

    function easeEnter(t) {
      return cubicBezier(t, 0.32, 0.08, 0.24, 1);
    }

    // Fast-start ease-out used when a navigation interrupts one already in
    // flight (rapid repeated clicks) so chained hops stay continuous instead of
    // re-entering the slow ease-in ramp on every click.
    function easeOut(t) {
      return cubicBezier(t, 0.22, 1, 0.36, 1);
    }

    function animateScroll(viewport, targetLeft, duration, onCancelRef, ease) {
      ease = ease || easeEnter;

      if (reducedMotion || Math.abs(viewport.scrollLeft - targetLeft) < 1) {
        viewport.scrollLeft = targetLeft;
        return Promise.resolve();
      }

      var start = viewport.scrollLeft;
      var delta = targetLeft - start;
      var cancelled = false;
      var frameId;

      if (onCancelRef) {
        onCancelRef.current = function () {
          cancelled = true;
          if (frameId) cancelAnimationFrame(frameId);
          viewport.style.scrollSnapType = '';
          viewport.style.scrollBehavior = '';
        };
      }

      viewport.style.scrollSnapType = 'none';
      viewport.style.scrollBehavior = 'auto';

      return new Promise(function (resolve) {
        var startTime = performance.now();

        function frame(now) {
          if (cancelled) {
            resolve();
            return;
          }

          var elapsed = now - startTime;
          var progress = Math.min(elapsed / duration, 1);
          viewport.scrollLeft = start + delta * ease(progress);
          if (progress < 1) {
            frameId = requestAnimationFrame(frame);
          } else {
            viewport.style.scrollSnapType = '';
            viewport.style.scrollBehavior = '';
            resolve();
          }
        }

        frameId = requestAnimationFrame(frame);
      });
    }

    class ThemeCarousel extends HTMLElement {
      constructor() {
        super();
        this._built = false;
        this._positions = [0];
        this._inset = 0;
        this._activePage = 0;
        this._scrollRaf = null;
        this._autoplayTimer = null;
        this._autoplayPaused = false;
        this._scrollAnimating = false;
        this._lastSlideIndex = 0;
        this._motionFrame = null;
        this._motionCancel = null;
        this._dragState = null;
        this._wasDragged = false;
        this._onScroll = this._handleScroll.bind(this);
        this._onResize = this._handleResize.bind(this);
      }

      connectedCallback() {
        if (this._built) return;
        this._applyAttributes();
        this._build();
        this._bind();
        this._built = true;
        this._lastSlideIndex = this.getActiveSlideIndex();
        this._sync(true);
        this._setupAutoplay();
        this._setupIntersectionObserver();
      }

      disconnectedCallback() {
        this._cancelMotion();
        this._clearAutoplay();
        if (this._observer) this._observer.disconnect();
        if (this._io) this._io.disconnect();
        if (this._viewport) this._viewport.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
      }

      _cancelMotion() {
        if (this._motionFrame) {
          cancelAnimationFrame(this._motionFrame);
          this._motionFrame = null;
        }
        if (this._motionCancel) {
          this._motionCancel();
          this._motionCancel = null;
        }
        if (this._viewport) {
          this._viewport.classList.remove('is-dragging');
          this._viewport.style.scrollSnapType = '';
          this._viewport.style.scrollBehavior = '';
        }
        this._scrollAnimating = false;
      }

      _disableSnap() {
        if (!this._viewport) return;
        this._viewport.style.scrollSnapType = 'none';
        this._viewport.style.scrollBehavior = 'auto';
      }

      _restoreSnap() {
        if (!this._viewport) return;
        this._viewport.style.scrollSnapType = '';
        this._viewport.style.scrollBehavior = '';
      }

      static get observedAttributes() {
        return ['gap', 'peek', 'per-view', 'loop', 'autoplay', 'arrows', 'dots', 'snap'];
      }

      attributeChangedCallback() {
        if (!this._built) return;
        this._applyAttributes();
        this._sync(true);
      }

      getActiveIndex() {
        return this._activePage;
      }

      goTo(pageIndex, options) {
        options = options || {};
        var positions = this._positions;
        var safeIndex = Math.max(0, Math.min(pageIndex, positions.length - 1));
        if (positions[safeIndex] == null) return Promise.resolve();

        // Capture whether we're interrupting a running animation before
        // _cancelMotion() clears the flag — used to pick a continuous, fast
        // ease for chained clicks.
        var interrupting = this._scrollAnimating;

        this._cancelMotion();
        this._dragState = null;
        this._scrollAnimating = true;

        // Track the latest navigation so a superseded animation (from rapid
        // repeated clicks) can't finalize stale state. Advance the active page
        // synchronously so consecutive clicks accumulate (next → next → next)
        // instead of every click re-targeting the same neighbouring slide.
        this._navToken = (this._navToken || 0) + 1;
        var token = this._navToken;
        this._activePage = safeIndex;
        this._updateUi();

        var duration = interrupting ? 300 : SCROLL_DURATION;
        var ease = interrupting ? easeOut : easeEnter;
        var cancelRef = { current: null };
        var promise = animateScroll(this._viewport, positions[safeIndex], duration, cancelRef, ease);
        this._motionCancel = function () {
          if (cancelRef.current) cancelRef.current();
        };

        return promise.then(
          function () {
            if (token !== this._navToken) return;
            this._motionCancel = null;
            this._scrollAnimating = false;
            this._lastSlideIndex = this.getActiveSlideIndex();
            this._updateUi();
            this._emitChange();
          }.bind(this)
        );
      }

      getActiveSlideIndex() {
        var slides = this._getSlides();
        if (!slides.length) return 0;

        var scrollLeft = this._viewport.scrollLeft;
        var inset = this._inset;
        var activeSlide = 0;
        var minDistance = Infinity;

        slides.forEach(function (slide, i) {
          var distance = Math.abs(slide.offsetLeft - inset - scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            activeSlide = i;
          }
        });

        return activeSlide;
      }

      goToSlide(slideIndex) {
        var slides = this._getSlides();
        if (!slides.length) return Promise.resolve();

        var safeSlide = Math.max(0, Math.min(slideIndex, slides.length - 1));
        var positions = this._positions;
        var bestPage = 0;
        var minDistance = Infinity;

        positions.forEach(
          function (pos, pageIndex) {
            var distance = Math.abs(pos - (slides[safeSlide].offsetLeft - this._inset));
            if (distance < minDistance) {
              minDistance = distance;
              bestPage = pageIndex;
            }
          }.bind(this)
        );

        return this.goTo(bestPage);
      }

      _applyAttributes() {
        var gap = this.getAttribute('gap');
        var peek = this.getAttribute('peek');
        var perView = this.getAttribute('per-view');
        var snap = this.getAttribute('snap') || 'start';

        if (gap != null) this.style.setProperty('--carousel-gap', gap + 'px');
        if (peek != null) this.style.setProperty('--carousel-peek', peek + 'px');
        if (perView != null) this.style.setProperty('--carousel-per-view', perView);
        this.style.setProperty('--carousel-snap-align', snap === 'center' ? 'center' : 'start');

        this.dataset.arrows = this._resolveArrowsMode();
        this.dataset.dots = parseBool(this.getAttribute('dots'), false) ? 'true' : 'false';
        this.dataset.loop = parseBool(this.getAttribute('loop'), false) ? 'true' : 'false';

        if (this.closest('[data-reveal]')) {
          this.setAttribute('data-reveal-child', '');
        }
      }

      _resolveArrowsMode() {
        var value = this.getAttribute('arrows');
        if (value === 'false') return 'false';
        if (value === 'desktop') return 'desktop';
        if (value === 'true' || value === '') return 'true';
        if (window.matchMedia('(min-width: 990px)').matches && value == null) return 'true';
        return 'false';
      }

      _build() {
        var existingSlides = Array.prototype.slice.call(this.children);
        var inReveal = this.hasAttribute('data-reveal-child');

        this._viewport = document.createElement('div');
        this._viewport.className = 'theme-carousel__viewport';
        this._viewport.setAttribute('tabindex', '0');

        this._track = document.createElement('div');
        this._track.className = 'theme-carousel__track';

        existingSlides.forEach(
          function (slide, index) {
            slide.classList.add('theme-carousel__slide');
            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-roledescription', 'slide');
            slide.setAttribute('aria-label', this._slideLabel(index + 1));
            if (inReveal) slide.setAttribute('data-reveal-item', '');
            this._track.appendChild(slide);
          }.bind(this)
        );

        this._viewport.appendChild(this._track);

        var fragment = document.createDocumentFragment();
        fragment.appendChild(this._viewport);

        if (this.dataset.arrows !== 'false') {
          this._prevBtn = this._createArrow('prev');
          this._nextBtn = this._createArrow('next');
          fragment.appendChild(this._prevBtn);
          fragment.appendChild(this._nextBtn);
        }

        if (this.dataset.dots === 'true') {
          this._dotsRoot = document.createElement('div');
          this._dotsRoot.className = 'theme-carousel__dots';
          this._dotsRoot.setAttribute('role', 'tablist');
          this._dotsRoot.hidden = true;
          fragment.appendChild(this._dotsRoot);
        }

        this.appendChild(fragment);

        if (!this.getAttribute('role')) this.setAttribute('role', 'region');
        this.setAttribute('aria-roledescription', 'carousel');
        this._updateLiveRegion();
      }

      _slideLabel(index) {
        var template = this.getAttribute('data-slide-label') || 'Slide __INDEX__';
        return template.replace('__INDEX__', String(index));
      }

      _createArrow(direction) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'theme-carousel__arrow theme-carousel__arrow--' + direction;
        btn.setAttribute(
          'aria-label',
          direction === 'prev'
            ? this.getAttribute('data-prev-label') || 'Previous slide'
            : this.getAttribute('data-next-label') || 'Next slide'
        );
        btn.innerHTML =
          direction === 'prev'
            ? '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12 4l-6 6 6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            : '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M8 4l6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        return btn;
      }

      _bind() {
        this._viewport.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize);

        if (this._prevBtn) {
          this._prevBtn.addEventListener('click', this._onPrevClick.bind(this));
        }
        if (this._nextBtn) {
          this._nextBtn.addEventListener('click', this._onNextClick.bind(this));
        }
        if (this._dotsRoot) {
          this._dotsRoot.addEventListener('click', this._onDotsClick.bind(this));
        }

        this.addEventListener('keydown', this._onKeydown.bind(this));
        this.addEventListener('mouseenter', this._pauseAutoplay.bind(this));
        this.addEventListener('mouseleave', this._resumeAutoplay.bind(this));
        this.addEventListener('focusin', this._pauseAutoplay.bind(this));
        this.addEventListener('focusout', this._resumeAutoplay.bind(this));
        this.addEventListener('touchstart', this._pauseAutoplay.bind(this), { passive: true });
        this.addEventListener('touchend', this._resumeAutoplay.bind(this), { passive: true });

        this._bindDrag();
      }

      _computeVelocity(samples) {
        if (!samples || samples.length < 2) return 0;
        var first = samples[0];
        var last = samples[samples.length - 1];
        var dt = last.time - first.time;
        if (dt <= 0) return 0;
        return (last.scrollLeft - first.scrollLeft) / dt;
      }

      _getSnapTargetForScroll(releaseVelocity) {
        var positions = this._getSnapPositions();
        var viewport = this._viewport;
        var scrollLeft = viewport.scrollLeft;
        var snapMode = this.getAttribute('snap') || 'start';
        var candidates = positions.slice();

        if (snapMode === 'center') {
          var slides = this._getSlides();
          var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
          slides.forEach(function (slide) {
            var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            var pos = slideCenter - viewport.clientWidth / 2;
            pos = Math.max(0, Math.min(pos, maxScroll));
            if (candidates.indexOf(pos) === -1) candidates.push(pos);
          });
          candidates.sort(function (a, b) {
            return a - b;
          });
        }

        if (releaseVelocity && Math.abs(releaseVelocity) >= FLICK_VELOCITY) {
          var currentPage = this._getActivePageIndex(positions);
          if (releaseVelocity > 0) {
            return candidates[Math.min(currentPage + 1, candidates.length - 1)];
          }
          return candidates[Math.max(currentPage - 1, 0)];
        }

        var best = candidates[0];
        var minDistance = Infinity;
        candidates.forEach(function (pos) {
          var distance = Math.abs(pos - scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            best = pos;
          }
        });
        return best;
      }

      _finishSettle() {
        this._restoreSnap();
        this._scrollAnimating = false;
        this._sync(true);
        this._lastSlideIndex = this.getActiveSlideIndex();
        this._emitChange();
        this._resumeAutoplay();
      }

      _settleToSnap(releaseVelocity) {
        var self = this;
        var viewport = this._viewport;
        var target = this._getSnapTargetForScroll(releaseVelocity);

        this._cancelMotion();
        this._disableSnap();
        this._scrollAnimating = true;

        if (reducedMotion || Math.abs(viewport.scrollLeft - target) < 1) {
          viewport.scrollLeft = target;
          self._finishSettle();
          return;
        }

        var start = viewport.scrollLeft;
        var delta = target - start;
        var startTime = performance.now();

        function frame(now) {
          var elapsed = now - startTime;
          var progress = Math.min(elapsed / SETTLE_DURATION, 1);
          viewport.scrollLeft = start + delta * easeEnter(progress);
          if (progress < 1) {
            self._motionFrame = requestAnimationFrame(frame);
          } else {
            self._motionFrame = null;
            self._finishSettle();
          }
        }

        self._motionFrame = requestAnimationFrame(frame);
      }

      _runMomentum(initialVelocity) {
        var self = this;
        var viewport = this._viewport;
        var velocity = initialVelocity;
        var lastTime = performance.now();

        self._disableSnap();
        self._scrollAnimating = true;

        function frame(now) {
          var dt = now - lastTime;
          lastTime = now;
          if (dt <= 0) {
            self._motionFrame = requestAnimationFrame(frame);
            return;
          }

          viewport.scrollLeft += velocity * dt;
          velocity *= Math.pow(0.92, dt / 16);

          if (Math.abs(velocity) < MOMENTUM_MIN_VELOCITY) {
            self._motionFrame = null;
            self._settleToSnap(velocity);
            return;
          }

          self._motionFrame = requestAnimationFrame(frame);
        }

        self._motionFrame = requestAnimationFrame(frame);
      }

      _bindDrag() {
        var viewport = this._viewport;
        var self = this;

        viewport.addEventListener(
          'dragstart',
          function (event) {
            event.preventDefault();
          },
          { passive: false }
        );

        viewport.addEventListener(
          'click',
          function (event) {
            if (self._wasDragged) {
              event.preventDefault();
              event.stopImmediatePropagation();
              self._wasDragged = false;
            }
          },
          true
        );

        viewport.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (event.target.closest('.theme-carousel__arrow')) return;

          self._cancelMotion();
          self._pauseAutoplay();

          self._dragState = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startScrollLeft: viewport.scrollLeft,
            dragging: false,
            velocitySamples: [
              {
                time: performance.now(),
                scrollLeft: viewport.scrollLeft,
                x: event.clientX
              }
            ]
          };
        });

        viewport.addEventListener(
          'pointermove',
          function (event) {
            if (!self._dragState || event.pointerId !== self._dragState.pointerId) return;

            var state = self._dragState;
            var deltaX = event.clientX - state.startX;

            if (!state.dragging) {
              if (Math.abs(deltaX) < DRAG_THRESHOLD) return;
              state.dragging = true;
              viewport.classList.add('is-dragging');
              self._disableSnap();
              if (viewport.setPointerCapture) viewport.setPointerCapture(event.pointerId);
            }

            event.preventDefault();
            viewport.scrollLeft = state.startScrollLeft - deltaX;

            var now = performance.now();
            state.velocitySamples.push({
              time: now,
              scrollLeft: viewport.scrollLeft,
              x: event.clientX
            });

            while (
              state.velocitySamples.length > 1 &&
              now - state.velocitySamples[0].time > VELOCITY_WINDOW
            ) {
              state.velocitySamples.shift();
            }
          },
          { passive: false }
        );

        function finishDrag(event) {
          if (!self._dragState || event.pointerId !== self._dragState.pointerId) return;

          var state = self._dragState;
          self._dragState = null;

          if (viewport.hasPointerCapture && viewport.hasPointerCapture(event.pointerId)) {
            viewport.releasePointerCapture(event.pointerId);
          }

          if (!state.dragging) {
            self._resumeAutoplay();
            return;
          }

          viewport.classList.remove('is-dragging');
          self._wasDragged = true;

          var velocity = self._computeVelocity(state.velocitySamples);

          if (reducedMotion || Math.abs(velocity) < MOMENTUM_MIN_VELOCITY) {
            self._settleToSnap(velocity);
            return;
          }

          self._runMomentum(velocity);
        }

        viewport.addEventListener('pointerup', finishDrag);
        viewport.addEventListener('pointercancel', finishDrag);
      }

      _getSlides() {
        return Array.prototype.slice.call(this._track.children);
      }

      _getSnapPositions() {
        var track = this._track;
        var viewport = this._viewport;
        var slides = this._getSlides();
        var maxScroll = Math.max(0, track.scrollWidth - viewport.clientWidth);

        if (maxScroll <= 2 || !slides.length) return [0];

        var positions = [];
        var seen = {};

        function addPosition(pos) {
          var key = Math.round(pos);
          if (seen[key]) return;
          seen[key] = true;
          positions.push(pos);
        }

        addPosition(0);

        var inset = this._inset;
        slides.forEach(function (slide) {
          var pos = slide.offsetLeft - inset;
          if (pos < 0) pos = 0;
          if (pos <= maxScroll + 2) addPosition(pos);
        });

        addPosition(maxScroll);

        positions.sort(function (a, b) {
          return a - b;
        });

        var merged = [positions[0]];
        for (var i = 1; i < positions.length; i++) {
          if (Math.abs(positions[i] - merged[merged.length - 1]) > 2) {
            merged.push(positions[i]);
          }
        }

        return merged;
      }

      _getActivePageIndex(positions) {
        var scrollLeft = this._viewport.scrollLeft;
        var active = 0;
        var minDistance = Infinity;

        positions.forEach(function (pos, i) {
          var distance = Math.abs(pos - scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            active = i;
          }
        });

        return active;
      }

      _handleScroll() {
        if (this._scrollAnimating || this._dragState) return;
        if (this._scrollRaf) return;
        this._scrollRaf = requestAnimationFrame(
          function () {
            this._scrollRaf = null;
            var prevSlide = this._lastSlideIndex;
            this._sync(false);
            var slideIndex = this.getActiveSlideIndex();
            if (slideIndex !== prevSlide) {
              this._lastSlideIndex = slideIndex;
              this._emitChange();
            }
          }.bind(this)
        );
      }

      _handleResize() {
        this._sync(true);
      }

      _computeInset() {
        // Leading scroll inset in px for full-bleed carousels (scroll-padding).
        // Zero for normal carousels, so the snap math is unchanged for them.
        if (!this._viewport) return 0;
        var value = parseFloat(getComputedStyle(this._viewport).scrollPaddingLeft);
        return isNaN(value) ? 0 : value;
      }

      _sync(force) {
        if (force) this._inset = this._computeInset();
        var positions = this._getSnapPositions();
        var changed = force || positions.length !== this._positions.length;
        this._positions = positions;
        this._activePage = this._getActivePageIndex(positions);
        this._updateUi();
        if (changed) this._updateLiveRegion();
      }

      _updateUi() {
        var positions = this._positions;
        var active = this._activePage;
        var loop = this.dataset.loop === 'true';
        var atStart = active <= 0;
        var atEnd = active >= positions.length - 1;

        if (this._prevBtn) {
          this._prevBtn.disabled = !loop && atStart;
        }
        if (this._nextBtn) {
          this._nextBtn.disabled = !loop && atEnd;
        }

        if (this._dotsRoot) {
          this._renderDots(positions, active);
        }

        var slides = this._getSlides();
        slides.forEach(
          function (slide, index) {
            var pageForSlide = this._pageForSlide(slide, positions);
            slide.setAttribute('aria-hidden', pageForSlide === active ? 'false' : 'true');
          }.bind(this)
        );
      }

      _pageForSlide(slide, positions) {
        var offset = slide.offsetLeft - this._inset;
        var best = 0;
        var minDistance = Infinity;
        positions.forEach(function (pos, i) {
          var distance = Math.abs(pos - offset);
          if (distance < minDistance) {
            minDistance = distance;
            best = i;
          }
        });
        return best;
      }

      _renderDots(positions, active) {
        if (!this._dotsRoot) return;

        if (positions.length <= 1) {
          this._dotsRoot.hidden = true;
          this._dotsRoot.innerHTML = '';
          return;
        }

        this._dotsRoot.hidden = false;
        var paginationLabel = this.getAttribute('data-pagination-label') || 'Carousel pagination';
        this._dotsRoot.setAttribute('aria-label', paginationLabel);

        var fragment = document.createDocumentFragment();
        for (var i = 0; i < positions.length; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'theme-carousel__dot' + (i === active ? ' is-active' : '');
          dot.setAttribute('data-carousel-dot', String(i));
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', this._slideLabel(i + 1));
          dot.setAttribute('aria-selected', i === active ? 'true' : 'false');
          fragment.appendChild(dot);
        }

        this._dotsRoot.innerHTML = '';
        this._dotsRoot.appendChild(fragment);
      }

      _updateLiveRegion() {
        if (!this._liveRegion) {
          this._liveRegion = document.createElement('div');
          this._liveRegion.className = 'theme-carousel__sr-only';
          this._liveRegion.setAttribute('aria-live', 'polite');
          this._liveRegion.setAttribute('aria-atomic', 'true');
          this.appendChild(this._liveRegion);
        }

        var total = this._positions.length;
        var current = this._activePage + 1;
        var template = this.getAttribute('data-status-label') || 'Slide __CURRENT__ of __TOTAL__';
        this._liveRegion.textContent = template
          .replace('__CURRENT__', String(current))
          .replace('__TOTAL__', String(total));
      }

      _onPrevClick(event) {
        event.preventDefault();
        var next = this._activePage - 1;
        if (next < 0) {
          if (this.dataset.loop === 'true') next = this._positions.length - 1;
          else return;
        }
        this.goTo(next);
      }

      _onNextClick(event) {
        event.preventDefault();
        var next = this._activePage + 1;
        if (next >= this._positions.length) {
          if (this.dataset.loop === 'true') next = 0;
          else return;
        }
        this.goTo(next);
      }

      _onDotsClick(event) {
        var dot = event.target.closest('[data-carousel-dot]');
        if (!dot) return;
        event.preventDefault();
        this.goTo(Number(dot.getAttribute('data-carousel-dot')));
      }

      _onKeydown(event) {
        if (!this.contains(document.activeElement) && document.activeElement !== this._viewport) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this._onPrevClick(event);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this._onNextClick(event);
        }
      }

      _emitChange() {
        this.dispatchEvent(
          new CustomEvent('theme-carousel:change', {
            bubbles: true,
            detail: {
              index: this._activePage,
              slideIndex: this.getActiveSlideIndex()
            }
          })
        );
      }

      _setupAutoplay() {
        this._clearAutoplay();
        var interval = parseInt(this.getAttribute('autoplay'), 10);
        if (!interval || interval < 500 || reducedMotion) return;

        this._autoplayInterval = interval;
        this._resumeAutoplay();
      }

      _setupIntersectionObserver() {
        if (typeof IntersectionObserver === 'undefined') return;
        this._io = new IntersectionObserver(
          function (entries) {
            var visible = entries.some(function (entry) {
              return entry.isIntersecting && entry.intersectionRatio > 0.2;
            });
            this._offscreen = !visible;
            if (visible) this._resumeAutoplay();
            else this._pauseAutoplay();
          }.bind(this),
          { threshold: [0, 0.2, 0.5] }
        );
        this._io.observe(this);
      }

      _clearAutoplay() {
        if (this._autoplayTimer) {
          clearInterval(this._autoplayTimer);
          this._autoplayTimer = null;
        }
      }

      _pauseAutoplay() {
        this._autoplayPaused = true;
        this._clearAutoplay();
      }

      _resumeAutoplay() {
        if (!this._autoplayInterval || reducedMotion || this._offscreen) return;
        this._autoplayPaused = false;
        this._clearAutoplay();
        this._autoplayTimer = setInterval(
          function () {
            if (this._autoplayPaused || this._offscreen) return;
            var next = this._activePage + 1;
            if (next >= this._positions.length) {
              if (this.dataset.loop === 'true') next = 0;
              else next = 0;
            }
            this.goTo(next);
          }.bind(this),
          this._autoplayInterval
        );
      }
    }

    customElements.define('theme-carousel', ThemeCarousel);
  })();
  } catch(e) { console.error(e); }
})();

})();
